import { useMemo } from 'react';

import { useFormContext, useWatch } from 'react-hook-form';

import { TemplateStudioModel } from 'common/contracts';
import { templateStudioStateService } from 'state/template-studio.state.service';
import { z } from 'zod';

import { PromotionDesignsMetadata } from 'components/TemplatesStudio/DesignsMetadata/types';

import { templateStudioSchema } from '../../../validation-schema';
import { DesignSidebarItem } from '../Components/DesignSidebarItem';

const PROMOTION_OBJECT_PATH = 'promotion';

const getPromotionsDesignsByFilter = ({
  maxSupportedProducts,
  themes
}: {
  maxSupportedProducts: TemplateStudioModel['promotion']['maxSupportedProducts'];
  themes: TemplateStudioModel['promotion']['themes'];
}): PromotionDesignsMetadata[] => {
  const relevantPromotionDesigns =
    templateStudioStateService.relevantPromotionDesigns.get() || [];

  return relevantPromotionDesigns.filter((currentDesign) => {
    return (
      // Check if the current design supports the max number of products that the user filtered by
      currentDesign.maxSupportedProducts >= maxSupportedProducts &&
      (!themes || themes.length === 0 || themes.includes(currentDesign.theme))
    );
  });
};

export const PromotionDesignsSecondarySidebar: React.FC = () => {
  const { control } = useFormContext<z.infer<typeof templateStudioSchema>>();

  const promotionObject: TemplateStudioModel[typeof PROMOTION_OBJECT_PATH] =
    useWatch({
      control,
      name: PROMOTION_OBJECT_PATH
    });

  const { maxSupportedProducts, themes } = promotionObject;

  const designs = useMemo(() => {
    return getPromotionsDesignsByFilter({ maxSupportedProducts, themes });
  }, [maxSupportedProducts, themes]);

  return (
    <>
      {designs.map((design) => (
        <DesignSidebarItem
          key={design.id}
          {...design}
          blockDesignIdPath="promotion.selectedDesignId"
        />
      ))}
    </>
  );
};
